import {
  META_IMAGE,
  META_IMAGE_ALT,
  META_TWITTER_SITE
} from "../constants/config";

export function headMetaTags({
  title = "",
  description = "",
  type = "",
  url = "",
  image = "",
  imageAlt = ""
}) {
  // open graph tags
  const tagsToRender = [];

  if (title) {
    tagsToRender.push({
      vmid: "og:title",
      property: "og:title",
      content: title
    });

    tagsToRender.push({
      vmid: "twitter:title",
      name: "twitter:title",
      content: title
    });
  }

  if (description) {
    tagsToRender.push({
      vmid: "og:description",
      property: "og:description",
      content: description
    });

    tagsToRender.push({
      vmid: "twitter:description",
      name: "twitter:description",
      content: description
    });

    tagsToRender.push({
      vmid: "description",
      name: "description",
      content: description
    });
  }

  if (type) {
    tagsToRender.push({
      vmid: "og:type",
      property: "og:type",
      content: type
    });
  }

  if (url) {
    tagsToRender.push({
      vmid: "og:url",
      property: "og:url",
      content: url
    });
  }

  // image
  tagsToRender.push({
    vmid: "og:image",
    property: "og:image",
    content: image || META_IMAGE
  });

  tagsToRender.push({
    vmid: "twitter:image",
    name: "twitter:image",
    content: image || META_IMAGE
  });

  // image alt
  tagsToRender.push({
    vmid: "og:image:alt",
    property: "og:image:alt",
    content: imageAlt || META_IMAGE_ALT
  });
  tagsToRender.push({
    vmid: "twitter:image:alt",
    name: "twitter:image:alt",
    content: imageAlt || META_IMAGE_ALT
  });

  // card
  tagsToRender.push({
    vmid: "twitter:card",
    name: "twitter:card",
    content: "summary_large_image"
  });

  // twitter site
  tagsToRender.push({
    vmid: "twitter:site",
    name: "twitter:site",
    content: META_TWITTER_SITE
  });

  return tagsToRender;
}

export default headMetaTags;
